export const WARNING_TITLE = "Подписание будет отменено, если вы закроете окно";

export const WARNING_ANNOTATION =
  "Процесс подписания документов не будет выполнен";

export const CLOSE_BUTTON = "Остановить и закрыть";

export const CONTINUE_BUTTON = "Продолжить";
